// src/app/shared/utils/date-utils.ts
export class DateUtils {
    static today(): Date {
      return new Date();
    }
  
    static daysAgo(days: number): Date {
      const date = new Date();
      date.setDate(date.getDate() - days);
      return date;
    }
  
    static daysAhead(days: number): Date {
      const date = new Date();
      date.setDate(date.getDate() + days);
      return date;
    }
  
    static monthsAgo(months: number): Date {
      const date = new Date();
      date.setMonth(date.getMonth() - months);
      return date;
    }
  
    static monthsAhead(months: number): Date {
      const date = new Date();
      date.setMonth(date.getMonth() + months);
      return date;
    }
  }
  